import React, { Fragment } from "react";
import { FormInput } from "root/ReactHookForm/FormComponents/FormInput";
import { EMAIL_ALL_FIELDS } from "root/Modals/ModalEmailAll";

const FormFragmentTitle = ({data, watch, control, register, formErrors, sectionName, readOnly}) =>
{

    return (
        <Fragment>
            <div>
                <div>
                    <label className='form-label'>Title</label>
                    <FormInput control={control} register={register} sectionName={sectionName} formErrors={formErrors} name={EMAIL_ALL_FIELDS.TITLE}/>
                </div>
            </div>
        </Fragment>
    );
}

export default FormFragmentTitle;